import logObservers from './logObservers';

export default function observe(observer) {
	if (typeof observer === 'function') {
		const observerObj = {observer, logsToSend: []};
		logObservers.add(observerObj);
		return () => logObservers.delete(observerObj);
	}
}
